import { Clock, CheckCircle2, XCircle } from "lucide-react";

const S = {
  pending_coordinator: ["Pending · Coordinator", "bg-amber-50 text-amber-700 ring-amber-200", Clock],
  pending_principal: ["Pending · Principal", "bg-orange-50 text-orange-700 ring-orange-200", Clock],
  approved: ["Approved", "bg-emerald-50 text-emerald-700 ring-emerald-200", CheckCircle2],
  rejected: ["Rejected", "bg-rose-50 text-rose-700 ring-rose-200", XCircle],
};

export function ApprovalBadge({ status, testid }) {
  const [label, cls, Icon] = S[status || "approved"] || S.approved;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full ring-1 transition-colors ${cls}`}>
      <Icon size={12} />{label}
    </span>
  );
}

export function RejectReason({ item }) {
  if (item?.approval !== "rejected" || !item.review_reason) return null;
  return <div data-testid={`reject-reason-${item.id}`} className="mt-2 text-xs rounded-lg bg-rose-50 text-rose-700 px-3 py-2"><span className="font-semibold">Sent back{item.reviewed_by ? ` by ${item.reviewed_by}` : ""}:</span> {item.review_reason}</div>;
}
